// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"12fae5a4","328":"092c05a4"}[chunkId] + ".chunk.js";
};